import * as React from "react";
import { Box, Button } from "@chakra-ui/react";
import { FiRefreshCw } from "react-icons/fi";

type Props = {
  onRefresh?: () => void | Promise<void>;
  isLoading?: boolean;
  refreshDisabled?: boolean;
};

const ReceiverAccountSearchToolbar: React.FC<Props> = ({
  onRefresh = () => {},
  isLoading = false,
  refreshDisabled = false,
}) => {
  return (
    <div className="mb-3 flex items-center justify-between">
      <h3 className="text-xl font-semibold text-navy-700 dark:text-white">
        Receiver Accounts
      </h3>

      <Box className="flex items-center justify-between gap-3">
        <Button
          variant="outline"
          onClick={onRefresh}
          isDisabled={isLoading || refreshDisabled}
          className="h-9 rounded-md border border-gray-300 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
          leftIcon={<FiRefreshCw size={16} />}
        >
          Refresh
        </Button>
      </Box>
    </div>
  );
};

export default ReceiverAccountSearchToolbar;
